import {
    Component,
    Input,
    OnInit,
    ViewChild,
    ViewEncapsulation,
    ElementRef,
    Renderer2,
    Output,
    EventEmitter, inject
} from '@angular/core';
import {SolrEntityService, EntityTreeService} from "@signature-it/ngx-entity/services";
import {ActivatedRoute, Router} from "@angular/router";
// import {TreeComponent, TreeNode} from "@circlon/angular-tree-component";
import {ShareDataService, AccessibilityService} from "@signature-it/ngx-generic/services";
import {EntityConfig} from "@signature-it/ngx-generic/config";
import {TreeItemLink, TreeLinks} from "@signature-it/ngx-entity/models";
import { LanguageService } from "@signature-it/ngx-generic/services";
declare let _;
let instanceNumber = 0;

@Component({
    selector: 'taxonomy-menu',
    templateUrl: './taxonomy-menu.component.html',
    styleUrls: ['./taxonomy-menu.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class TaxonomyMenuComponent implements OnInit{
    cmpID = instanceNumber++;

    @Input() entityTypeVar: string;
    @Input() nodeEntityVar: string;
    @Input() expandAll: boolean = false;
    @Input() hideSiblings: boolean = false;
    @Input() openOnlyOneNode: boolean = false;
    @Input() isTreePattern: boolean = false;
    @Input() transitionPoint: string = 'lg';
    @Input() disableBsClasses: boolean = false;
    @Input() level1V: boolean = false;
    @Input() level2H: boolean = false;
    @Input() expandByHover: boolean = false;
    @Input() key = 'default';
    @Input() displayMode: string = 'dropdown';
    @Input() headingLevel: number;
    @Input() level2MobileAccordion = false;
    @Input() taxonomyTypeVar: string;
    @Input() nodeVar: string;
    @Input() depth: string;
    @Input() enableTaxonomySubjectSearch: boolean = false;
    @Input() selectedDefault: string;
    @Output() onChangeMenu: EventEmitter<string> = new EventEmitter<string>();
    @Input() selectedOnMenu: string;
    @Input() selectPanelClass: string;
    @ViewChild('treeCmp') protected treeCmp;

    entityConfig;
    tree = {
        loading: false,
        options: {
            rtl: false
        },
        nodes:  []
    };
    selectedNode;
    currentExpendNode;
    currentUrl: String;
    singleLevel: TreeLinks;
    currentItemLink: TreeItemLink;
    currentLevel: number;
    dir: string = '';
    protected langSvc: LanguageService = inject(LanguageService);
    constructor(protected solrEntityService: SolrEntityService,
                protected entityService: EntityTreeService,
                protected activatedRoute: ActivatedRoute,
                public router:Router,
                public shareDataService: ShareDataService,
                protected host: ElementRef,
                protected renderer: Renderer2,
                public a11ySvc: AccessibilityService) {}
    ngOnInit() {
        const currLang = this.langSvc.getCurrentLanguage();
        if (currLang) {
            this.dir = this.langSvc.getDirByLang(currLang.code);
        }
        this.currentUrl = location.origin + '/';
        this.taxonomyTypeVar = this.taxonomyTypeVar || this.entityTypeVar;
        this.nodeVar = this.nodeVar || this.nodeEntityVar;
        this.entityService.getTaxonomyMenu(this.taxonomyTypeVar, this.nodeVar, this.depth).subscribe(
            res => {
                this.tree.nodes = res;
                this.afterTreeInit(this.tree);
                //Set default item selected
                var selectedOnMenuUrl;
                if (this.enableTaxonomySubjectSearch) {
                    this.tree.nodes.forEach(item => {
                        if (!selectedOnMenuUrl) {
                            if (this.selectedOnMenu) {
                                if (item.name == this.selectedOnMenu) {
                                    selectedOnMenuUrl = item.url;
                                }
                            } else {
                                selectedOnMenuUrl = item.url;
                                this.selectedOnMenu = item.name;
                            }
                        }
                    });
                    if(selectedOnMenuUrl) {
                        this.onChangeMenu.emit(selectedOnMenuUrl);
                    }
                }
                if(this.displayMode == 'flat_single_level') {
                    this.singleLevel = new TreeLinks( res);
                    this.singleLevel.init();
                    this.currentItemLink = this.singleLevel.treeItems[0];
                    this.currentLevel = 1;
                }
            },
            error => {

            }
        );

        this.entityConfig = EntityConfig.ngxTaxonomyMenu[this.key];
        if(this.entityConfig?.responsive && Object.keys(this.entityConfig?.responsive).length !== 0){
            this.displayMode = this.getResponsiveConfigProperty(this.entityConfig?.responsive, 'displayMode');
            this.headingLevel = this.getResponsiveConfigProperty(this.entityConfig?.responsive, 'headingLevel');
        }
    }

    afterTreeInit(tree){

    }

    getResponsiveConfigProperty(responsiveEntityConfig = {}, property = ''){
        let responsiveKeys = _.keys(responsiveEntityConfig);
        const currentKey = this.shareDataService.getCurrentBp(responsiveKeys);
        return responsiveEntityConfig[currentKey][property];
    }

    initializedTree() {
        if(this.expandAll) {
            this.treeCmp.treeModel.expandAll();
        }
        const selectedNodePath = this.getActiveNode({'children': this.tree.nodes}, this.router.url);
        console.log(selectedNodePath);
        if(selectedNodePath) {
            selectedNodePath.reverse().forEach(item => {
                let selectedNodeItem = this.treeCmp.treeModel.getNodeById(item);
                selectedNodeItem.expand();
            })
        }
    }

    expandNode(event,node) {
        // event.stopPropagation();
        // event.preventDefault();
        // node.toggleExpanded();
    }

    onExpandNode($event) {
        if(this.openOnlyOneNode && this.currentExpendNode){
            this.currentExpendNode.collapse();
        }
        this.currentExpendNode = $event.node;
        if(this.selectedNode == $event.node) {
            this.selectedNode = $event.node.parent;
        } else if($event.node.children?.length){
            this.selectedNode = $event.node;
        }
    }

    isExternalLink(link) {
        return /^https?:\/\//i.test(link);
    }

    getActiveNode(node, url) {
        if(node['url'] == url) {
            return [node['id']];
        }
        if( node['children']) {
            for (let i = 0; i < node['children'].length; i++) {
                let temp = this.getActiveNode(node['children'][i], url);
                if(temp) {
                    if(node['id']) temp.push(node['id']);
                    return temp;
                }
            }
        }
        return null;

    }

    onMobileSubmenuClick(e, menuLevel){
        let trigger = e.target;
        let menuUl = trigger.nextElementSibling;
        let menuWrapper = trigger.parentElement;


        // first - if target menu is now opening - close all opened 2nd-level menus
        if(this.level2MobileAccordion && menuLevel == 2 && menuUl.style.display === 'block'){
            let level2menus = this.host.nativeElement.querySelectorAll(".menu-level-2");
            for (let item of level2menus) {
                this.renderer.setAttribute(item.previousElementSibling, 'aria-expanded','false');
                this.renderer.removeClass(item.parentElement, 'expanded');
                this.renderer.setStyle(
                    item,
                    'max-height',
                    null
                );
            }
        }

        // then, open/close the target menu
        if(menuUl.style.display === 'block'){
            this.renderer.setStyle(menuUl, 'display', 'none');
            this.renderer.setStyle(menuUl, 'visibility', 'hidden');
            this.renderer.setAttribute(trigger, 'aria-expanded', 'false');
            this.renderer.removeClass(menuWrapper, 'expanded');
        } else {
            this.renderer.setStyle(menuUl, 'display', 'block');
            this.renderer.setStyle(menuUl, 'visibility', 'visible');
            this.renderer.setAttribute(trigger, 'aria-expanded', 'true');
            this.renderer.addClass(menuWrapper, 'expanded');
        }

    }

    navigateTo(link){
        if(/^https?:\/\//i.test(link)){
            window.location.href = link;
        } else if(link) {
            var queryParams = this.setQueryParams(link);
            this.router.navigate([link.split('?')[0]], {
                queryParams
            });
        }
    }

    setQueryParams(link) {
        const queryParamsString =  link.split('?')[1]? link.split('?')[1] : '';
        const queryParams = {};
        if(queryParamsString) {
            queryParamsString.split('&').forEach(x => {
                const params = x.split('=');
                queryParams[params[0]] = params[1];
            });
        }
        return  queryParams;
    }

    onTargetIdClicked(url, target: string = '_self', event = null){
        if(url == ""){
            return;
        }
        if (target != '_self' && event) {
            event.preventDefault();
        }
        if (this.enableTaxonomySubjectSearch) {
            this.tree.nodes.forEach(item => {
                if (item.name == url){
                    url = item.url;
                }
            });
            if(url) {
                this.onChangeMenu.emit(url);
            }
        } else {
            if (this.isExternalLink(url)) {
                window.open(url, target);
            } else {
                const urlPage = url.split('#')[0];
                const urlTarget = url.split('#')[1];
                this.router.navigate([]).then((result) => {
                    window.open(url, target);
                    this.a11ySvc.setFocusOnTab( // focus on the anchor target - for accessibility reasons
                        '#' + urlTarget,
                        0,
                        document.getElementById(urlTarget).scrollIntoView() // maybe this is unnecessary if every page inside the application is taking care of navigation events
                    );
                })
            }
        }

        // const urlPage = url.split('#')[0];
        // const urlTarget = url.split('#')[1];
        // this.router.navigate([urlPage, {externalUrl: url}], {fragment: urlTarget}).then(() => {
        //     this.a11ySvc.setFocusOnTab('#'+urlTarget); // focus on the anchor target
        // })

    }

    selectNode(node) {
        if(node.tree) {
            this.currentItemLink = node;
            this.currentLevel ++;
        }
    }
}
